import { Controller } from "remult";

@Controller("partner-organization-manager-methods")
export class PartnerOrganizationManagerMethods {}
